import { ChangeDetectionStrategy, Component, EventEmitter, HostListener, Input, Output } from '@angular/core';

const ALERT_LINK_ID = 'object-link';

@Component({
  selector: 'app-action-error-alert',
  templateUrl: './action-error-alert.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ActionErrorAlertComponent {
  get errorBodyTranslation(): string {
    return this.errorBodyTranslationKey
      ? this.buildTranslationKey('basicErrorBody')
      : this.buildTranslationKey('errorMessageWithoutReason');
  }

  get objectBodyTranslation(): string {
    return this.objectBodyTranslationKey ?? this.buildTranslationKey('basicObjectionBody');
  }

  @Input()
  customBaseTranslationKey?: string;

  @Input()
  actionTranslationKey: string;

  @Input()
  errorBodyTranslationKey: string;

  @Input()
  errorTranslationKey: string;

  @Input()
  objectTranslationKey: string;

  @Input()
  objectBodyTranslationKey: string;

  @Input()
  redirectAction: () => any;

  @Output()
  closeClick = new EventEmitter<void>();

  buildError(): string {
    return `<span>${this.errorTranslationKey}</span>`;
  }

  buildAction(): string {
    return `<span>${this.actionTranslationKey}</span>`;
  }

  buildObjectLink(): string {
    return `<a class="${ALERT_LINK_ID} font-bold cursor-pointer underline text-white">${this.objectTranslationKey}</a>`;
  }

  buildTranslationKey(relativeKey: string): string {
    if (this.customBaseTranslationKey) {
      return `${this.customBaseTranslationKey}.${relativeKey}`;
    }

    return `core.globalAlerts.actionAlert.${relativeKey}`;
  }

  @HostListener('click', ['$event'])
  private onClick(event: MouseEvent): void {
    const targetElement = event.target as HTMLElement;

    if (targetElement.classList.contains(ALERT_LINK_ID)) {
      if (typeof this.redirectAction === 'function') {
        this.redirectAction();
      }

      this.closeClick.emit();
    }
  }
}
